import {call, put, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {saveWebhooks, saveWebhookDeliveryLogs} from "../Actions/webhooks.actions";
import {
  getWebhooksAsync,
  createUpdateWebhookAsync,
  deleteWebhookAsync,
  getWebhookDeliveryLogsAsync,
} from "../AsyncActions/webhooks.async";

function* getWebhook(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getWebhooksAsync, pageUrl);
    if (response) {
      yield put(saveWebhooks(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* createUpdateWebhook(action = {}) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(createUpdateWebhookAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* deleteWebhook(action) {
  const {callback = () => {}, payload} = action;
  try {
    const response = yield call(deleteWebhookAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* getWebhookDeliveryLogs(action = {}) {
  const {pageUrl = "", webhookId} = action;
  try {
    const response = yield call(getWebhookDeliveryLogsAsync, pageUrl, webhookId);
    if (response) {
      yield put(saveWebhookDeliveryLogs(response?.data));
    }
  } catch (e) {
    return e;
  }
}

export function* sitesSaga() {
  yield takeLatest(actions.REQUEST_WEBHOOKS, getWebhook);
  yield takeLatest(actions.CREATE_UPDATE_WEBHOOK, createUpdateWebhook);
  yield takeLatest(actions.DELETE_WEBHOOK, deleteWebhook);
  yield takeLatest(actions.REQUEST_WEBHOOK_DELIVERY_LOGS, getWebhookDeliveryLogs);
}
